import baseApp from '../innerAPP'
import App from './App'

;(async () => {
  const vm = await baseApp(App)
  vm.mount('#app')
})()
